<template>
  <div class="tile is-parent">
    <article
      id="container"
      class="tile is-child box detail-page-tile">
      <div class="estimage-codemirror">
        <codemirror
          v-model="code"
          :options="options"
          :width="editorWidth" />
      </div>
    </article>
  </div>
</template>

<script>
import { codemirror } from '@/components/VueCodemirror'
// language js
import 'codemirror/mode/javascript/javascript.js'

export default {
  name: 'EstimageMessageDetail',
  components: {
    codemirror
  },
  props: {
    value: {
      type: String,
      default: ''
    },
    options: null
  },
  data() {
    return {
      code: '',
      editorWidth: 400
    }
  },
  computed: {},
  watch: {
    code: {
      handler: function (newVal, oldVal) {
        this.$emit('input', newVal)
      },
      deep: true
    }
  },
  created() {},
  mounted() {
    this.code = this.value
    // Auto-format JSON on load
    this.$nextTick(() => {
      if (this.code && this.tryParseJSON(this.code)) {
        this.formatJSON()
      }
    })
  },
  methods: {
    onCmReady(cm) {
      console.log('the editor is readied!', cm)
    },
    onCmFocus(cm) {
      console.log('the editor is focus!', cm)
    },
    onCmCodeChange(newCode) {
      console.log('this is new code', newCode)
      this.code = newCode
    },
    formatJSON() {
      try {
        // Parse and re-stringify with formatting
        const parsed = JSON.parse(this.code)
        this.code = JSON.stringify(parsed, null, 2)
      } catch (e) {
        console.error('Invalid JSON, could not format', e)
      }
    },
    tryParseJSON(jsonString) {
      try {
        const o = JSON.parse(jsonString)
        if (o && typeof o === 'object') {
          return true
        }
      } catch (e) {}
      return false
    }
  }
}
</script>

<style lang="scss">
.estimage-codemirror {
  // Height minus header and menu
  height: calc(100vh - 170px);
  width: 100%;
}
</style>